export default __webpack_public_path__ + "static/media/thumbnail-13.8c75d09a.jpg";